module.exports = __webpack_public_path__ + "static/media/gallery-polaroid-with-pin.905cdf34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-polaroid-with-pin.png
// module id = 1009
// module chunks = 0